var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"share-this"},[_c('div',{staticClass:"sharethis-inline-share-buttons custom-st",attrs:{"data-url":_vm.url,"data-image":_vm.imageUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }